import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'
import { fetchLastWeeklyReview } from '@/api/journal'
import type { JournalEntry } from '@/types'

export function useLastWeeklyReview(): JournalEntry | null | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.journal.lastWeeklyReview(),
    queryFn: fetchLastWeeklyReview,
  })
  return data
}
